import { Component, Input, ViewChild } from '@angular/core';
import { NgIf } from '@angular/common';
import { ChartConfiguration, ChartData, ChartEvent } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { MatButton } from '@angular/material/button';
import { UserEnergyEarnings } from '../../../models/dfs-events.models';

@Component({
  selector: 'app-leaderboard-chart',
  templateUrl: './leaderboard-chart.component.html',
  styleUrls: ['./leaderboard-chart.component.scss'],
  standalone: true,
  imports: [BaseChartDirective, NgIf],
})
export class LeaderBoardChartComponent {

  @Input() data: UserEnergyEarnings[] = [];

  ngOnChanges() {
    if (this.data.length) {
      this.updateChartData();
    }
  }

  private updateChartData() {
    this.barChartData = {
      ...this.barChartData,
      labels: this.data.map(item => item.name),
      datasets: [
        {
          ...this.barChartData.datasets[0],
          data: this.data.map(item => item.earnings),
        },  
      ]
    };
  }

  public barChartType = 'bar' as const;

  public barChartOptions: ChartConfiguration<'bar'>['options'] = {
    indexAxis: 'y', // <-- Horizontal
    responsive: false,
    maintainAspectRatio: false, // If you'd like to freely control width/height
    scales: {
      x: {
        beginAtZero: true,
        grid: {
          display: true,
        },
      },
      y: {
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      }
    },
  };

  public barChartData: ChartData<'bar'> = {
    labels: [],
    datasets: [
      {
        data: [],
        label: 'Savings (£)',
        backgroundColor: '#2995f3',
      }
    ],
  };


}
